import { ResumesUserFiltersResource } from 'src/services/resumes.js';
import {
  ageBoundaryTitle,
  ageRangeTitle,
  paymentBoundaryTitle,
  paymentRangeTitle,
} from 'src/utils/filters.js';
import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import FiltersProvider from 'src/components/filters/FiltersProvider/FiltersProvider.vue';
import SavedFiltersProvider from 'src/components/filters/SavedFiltersProvider/SavedFiltersProvider.vue';
import ResumeListPage from 'src/components/resumes/ResumeListPage/ResumeListPage.vue';
import VisitorProvider from 'src/components/users/VisitorProvider/VisitorProvider.vue';

const models = {
  currency: {
    default: 'RUR',
    isSelected: () => false,
  },
  salaryFrom: {
    title: paymentRangeTitle('salaryFrom', 'salaryTo', 'currency'),
    partOf: ['salaryTo'],
  },
  salaryTo: {
    title: paymentBoundaryTitle('to', 'currency'),
    isSelected: ({ items }) => {
      return items.salaryFrom === null;
    },
  },
  ageFrom: {
    title: ageRangeTitle('ageFrom', 'ageTo', 'Возраст: '),
    partOf: ['ageTo'],
  },
  ageTo: {
    title: ageBoundaryTitle('to', 'Возраст: '),
    isSelected: ({ items }) => {
      return items.ageFrom === null;
    },
  },
  locations: {
    title: ({ filters, title }) =>
      filters.excludeLocation ? `${title} (исключить)` : title,
  },
  experiences: {
    title: ({ title }) => `Опыт работы: ${title.toLowerCase()}`,
  },
  excludeLocation: {
    isSelected: () => false,
  },
  companies: {
    title: ({ filters, title }) => {
      if (filters.excludeCompany && filters.isCurrentCompany) {
        return `${title} (не текущее место работы)`;
      }
      if (filters.excludeCompany) {
        return `${title} (исключить)`;
      }
      if (filters.isCurrentCompany) {
        return `${title} (текущее место работы)`;
      }
      return title;
    },
  },
  excludeCompany: {
    isSelected: () => false,
  },
  isCurrentCompany: {
    isSelected: () => false,
  },
  searchFields: {
    isSelected: () => false,
  },
  universities: {
    title: ({ filters, title }) =>
      filters.excludeUniversity ? `${title} (исключить)` : title,
  },
  excludeUniversity: {
    isSelected: () => false,
  },
  extraEducations: {
    title: ({ filters, title }) =>
      filters.excludeExtraEducation ? `${title} (исключить)` : title,
  },
  excludeExtraEducation: {
    isSelected: () => false,
  },
  hasHighEducation: {
    title: 'С высшим образованием',
  },
  hasExtraEducation: {
    title: 'С доп. образованием',
  },
  hasExperience: {
    title: 'С опытом работы',
  },
  hasSalary: {
    title: 'Указана зарплата',
  },
  hasSocialRatings: {
    title: 'Участвует в профсообществах',
  },
  workStates: {
    // eslint-disable-next-line complexity
    title: ({ value }) => {
      switch (value) {
        case 'not_search':
          return 'Не ищет работу';
        case 'search':
          return 'Ищет работу';
        case 'ready':
          return 'Рассмотрит предложения';
        case 'remote':
          return 'Готов к удалённой работе';
        case 'relocation':
          return 'Готов к переезду';
        default:
          return '';
      }
    },
  },
};

const {
  isGuest,
  tabs,
  visitor,
  resumes,
  search,
  options,
  filtersData: dynamicOptions,
  emotionalFeedback,
  notificationInfo,
  suggest,
  promoVacancy,
} = getSsrState();

const { query, order, filters, savedFilters, groups } = search;

const app = createVueApp({
  render(h) {
    return h(
      VisitorProvider,
      { props: { visitor: { ...(visitor ?? {}), isGuest } } },
      [
        h(
          FiltersProvider,
          {
            props: {
              filters,
              options,
              dynamicOptions,
              models,
            },
          },
          [
            h(
              SavedFiltersProvider,
              {
                props: {
                  savedFilters,
                  resource: ResumesUserFiltersResource,
                },
              },
              [
                h(ResumeListPage, {
                  props: {
                    tabs,
                    resumes,
                    query,
                    order,
                    groups,
                    emotionalFeedback,
                    notificationInfo,
                    suggest,
                    promoVacancy,
                  },
                }),
              ],
            ),
          ],
        ),
      ],
    );
  },
});

app.$mount('[data-resume-list]');
